export const CONTACT = {
  phone: "(210) 660-6113",
  phoneHref: "tel:+12106606113",
  email: "smartibelle@icloud.com",
  emailHref: "mailto:smartibelle@icloud.com",
  area: "San Antonio & surrounding areas",
};

export const SERVICES = [
  {
    id: "regular",
    no: "01",
    title: "Regular Home Cleaning",
    short: "Weekly, bi-weekly or monthly upkeep that keeps your home reset.",
    points: ["Dusting & wipe-downs", "Kitchen & bathrooms", "Vacuum & mop floors"],
    price: 120,
    img: "/img/regular.jpg",
  },
  {
    id: "deep",
    no: "02",
    title: "Deep Cleaning",
    short: "Top-to-bottom detail for the corners routine cleans skip.",
    points: ["Baseboards & doors", "Inside appliances", "Grout & build-up"],
    price: 220,
    img: "/img/deep.jpg",
  },
  {
    id: "move",
    no: "03",
    title: "Move-In / Move-Out",
    short: "Empty-home cleaning so keys change hands spotless.",
    points: ["Inside cabinets & closets", "Appliances inside & out", "Walls spot-cleaned"],
    price: 280,
    img: "/img/move.jpg",
  },
  {
    id: "office",
    no: "04",
    title: "Office & Commercial",
    short: "After-hours cleaning for workspaces, studios and shops.",
    points: ["Desks & touchpoints", "Breakrooms & restrooms", "Flexible schedules"],
    price: 150,
    img: "/img/office.jpg",
  },
  {
    id: "construction",
    no: "05",
    title: "Post-Construction",
    short: "Dust, debris and residue removed after builds and renovations.",
    points: ["Fine dust removal", "Windows & fixtures", "Floor detailing"],
    price: 300,
    img: "/img/construction.jpg",
  },
  {
    id: "airbnb",
    no: "06",
    title: "Airbnb & Rental Turnovers",
    short: "Fast, consistent resets between guests so every stay starts five-star.",
    points: ["Linen change & beds", "Restock essentials", "Photo-ready staging"],
    price: 95,
    img: "/img/airbnb.jpg",
  },
];

export const SPECIALS = [
  { code: "NEWCITRINE", percent: 15, title: "First clean", text: "15% off your very first Citrine clean, any service." },
  { code: "RECURRING10", percent: 10, title: "Recurring plans", text: "10% off every visit when you book weekly or bi-weekly." },
  { code: "MILITARY10", percent: 10, title: "Military & PCS", text: "10% off for active duty, veterans and PCS move-outs." },
];

export const startingTotal = (ids) => SERVICES.filter((s) => ids.includes(s.id)).reduce((t, s) => t + s.price, 0);

export const SLOT_LABELS = {
  "08:00": "8:00 AM",
  "10:00": "10:00 AM",
  "12:00": "12:00 PM",
  "14:00": "2:00 PM",
  "16:00": "4:00 PM",
};

export const serviceTitle = (id) => SERVICES.find((s) => s.id === id)?.title ?? id;

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg ?? JSON.stringify(e)).join(" ");
  return detail?.msg ?? String(detail);
};

export const API = `${process.env.REACT_APP_BACKEND_URL ?? ""}/api`;
